






































import { Component, Vue } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import PanelService from '@/app/shared/components/panels/service.vue';
@Component({ components: { PanelService } })
export default class PanelProductComponent extends Vue {
  private get refs() {
    return refsService;
  }
  private get policy() {
    return this.refs.modules.policy.policy;
  }
}
